import * as React from "react";

import { connect } from "react-redux";

import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

const HealthSurveillanceOeukSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <ContextAwareProgressBarQuestionnaireSection
            {...props}
            {...sections.Oeuk}>
            <TextQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WhenWasYourLastOffshoreMedical)}
                readonly={props.readonly} />
            <TextQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WhenWasYourLastSurvivalCourse)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouPreviouslyHadAHearingTest)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HearingTestWasItNormal)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverBeenExposedToAsbestos)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverHadALungFunctionTest)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverHadAWorkRelatedMedicalCondition)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverHadAnAccidentAtWork)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HadAnyTimeOffWork4WeeksOrMoreInTheLast5Years)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverBeenMedivacedFromAnOffshoreInstallation)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HowManyCigarsDoYouSmokePerWeek)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HowMuchPipeOrRollingTobaccoDoYouSmokePerWeek)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DidYouVapeOrUseECigarettes)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverHadVaricoseVeins)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverHadLiverDiseaseIncludingJaundiceHepatitis)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DoYouHaveAChangeInBowelHabitsOrDiarrhoea)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverHadBloodInStoolsPilesOrHaemorrhoids)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouAnyHistoryOfAnyProblemsWithYourBladderOrKidneys)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouAnyHistoryOfAnyInfectiousDiseases)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverHadAnyOperations)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouBeenTreatedInHospitalInTheLast5Years)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AreYouAwaitingAnyFormOfMedicalTreatmentInHospital)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DoYouHaveAFearOfFlyingOrHeights)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouAttendedADentistInTheLastYear)}
                readonly={props.readonly} />
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AreYouUndergoingDentalTreatment)}
                readonly={props.readonly} />
            <TextQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.IfYesToAnyOfTheAbovePleaseProvideFurtherComments)}
                readonly={props.readonly}
                multiline={true} />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};

export const HealthSurveillanceOeukSection = connect(
    makeMapStateToQuestionnaireSectionProps(sections.Oeuk.id),
    mapDispatchToQuestionnaireSectionProps
)(HealthSurveillanceOeukSectionUnconnected);
